import { MessagingPlatform } from '@this+that/models';

// Gmail's draft version is the id of the draft's current message; Outlook's is a changeKey, so its row is read by draftId.
export const resolveServerRowId = (
  platform: MessagingPlatform | undefined,
  draftId: string,
  serverDraftVersion?: string,
): string =>
  platform === MessagingPlatform.GMAIL && serverDraftVersion
    ? serverDraftVersion
    : draftId;
